import { Stack, TextField } from '@mui/material';

import StepScreen from '@/karehero-app/access/StepScreen';
import { type Account } from '@/karehero-app/access/AccountBar';
import { LEGAL_NAME } from '@/karehero-app/tell-us-once/intake/content';

// The carer's own name, in the form the claim needs it. Option 1's screen for
// what option 2 asks in the chat.
const LegalNameScreen = ({
  onNext,
  onBack,
  account,
}: {
  onNext: () => void;
  onBack?: () => void;
  /** The app bar. See StepScreen's own `account`. */
  account?: Account;
}) => (
  <StepScreen
    account={account}
    title={LEGAL_NAME.title}
    description={LEGAL_NAME.description}
    primaryLabel={LEGAL_NAME.primary}
    onPrimary={onNext}
    onBack={onBack}
  >
    <Stack spacing={2}>
      {LEGAL_NAME.fields.map((label) => (
        <TextField key={label} label={label} variant='filled' fullWidth />
      ))}
    </Stack>
  </StepScreen>
);

export default LegalNameScreen;
